import axios from "axios";
import { API, authHeaders } from "@/lib/growthApi";

const CHUNK = 512 * 1024;
export const clientTokenKey = (slug) => `thrive_portal_${slug}`;
const clientHeaders = (slug) => ({ Authorization: `Bearer ${localStorage.getItem(clientTokenKey(slug)) || ""}` });

export const portal = {
  info: (slug) => axios.get(`${API}/portal/${slug}`).then((r) => r.data),
  unlock: (slug, access_code) => axios.post(`${API}/portal/${slug}/unlock`, { access_code }).then((r) => r.data),
  reports: (slug) => axios.get(`${API}/portal/${slug}/reports`, { headers: clientHeaders(slug) }).then((r) => r.data),
  fileUrl: (slug, id, kind, mode = "download") => `${API}/portal/${slug}/reports/${id}/file?kind=${kind}&mode=${mode}&auth=${encodeURIComponent(localStorage.getItem(clientTokenKey(slug)) || "")}`,
};

export const adminPortal = {
  clients: () => axios.get(`${API}/admin/clients`, { headers: authHeaders() }).then((r) => r.data),
  create: (body) => axios.post(`${API}/admin/clients`, body, { headers: authHeaders() }).then((r) => r.data),
  client: (id) => axios.get(`${API}/admin/clients/${id}`, { headers: authHeaders() }).then((r) => r.data),
  patch: (id, body) => axios.patch(`${API}/admin/clients/${id}`, body, { headers: authHeaders() }).then((r) => r.data),
  createReport: (id, body) => axios.post(`${API}/admin/clients/${id}/reports`, body, { headers: authHeaders() }).then((r) => r.data),
  deleteReport: (id) => axios.delete(`${API}/admin/reports/${id}`, { headers: authHeaders() }).then((r) => r.data),
  fileUrl: (id, kind, mode = "download") => `${API}/admin/reports/${id}/file?kind=${kind}&mode=${mode}&auth=${encodeURIComponent(localStorage.getItem("thrive_admin_token") || "")}`,
  async upload(file, kind, onProgress) {
    const { upload_id } = await axios.post(`${API}/admin/uploads`, null, { params: { kind, filename: file.name }, headers: authHeaders() }).then((r) => r.data);
    const total = Math.ceil(file.size / CHUNK);
    for (let i = 0; i < total; i++) {
      const fd = new FormData();
      fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
      await axios.post(`${API}/admin/uploads/${upload_id}/chunk`, fd, { params: { index: i }, headers: authHeaders() });
      onProgress?.(Math.round(((i + 1) / total) * 100));
    }
    return upload_id;
  },
};
